import http from '@/services/http'

export const indexTaxasRequest = (params) => {
  return http.get('empresas/taxas', {
    params: params
  })
}


export const storeTaxasRequest = (payload) => {
  return http.post('empresas/taxas', payload)
}

export const updateTaxasRequest = (id, payload) => {
  return http.put(`empresas/taxas/${id}`, payload)
}

export const showTaxasRequest = (id) => {
  return http.get(`empresas/taxas/${id}`)
}

export const indexEmpresasAlvarasRequest = (params) => {
  return http.get('empresas/alvarasTaxas', {
    params: params
  })
}

export const updateResponsavelRequest = (id, payload) => {
  return http.put(`empresas/alvarasTaxas/responsavel/${id}`, payload)
}

export const showtaxasEmpresaRequest = (params) => {
  return http.get('taxas-empresa/'+params.empresa_id, {
    params: params
  })
}

export const criarCheckAlvaraTaxaRequest = (id, payload) => {
  return http.put(`empresas/alvarasTaxas/check/${id}`, payload)
}



export const destroyTaxasRequest = (params) => {
  return http.delete(`empresas/taxas/${params.id}`,  {params:params})
}
